import React from 'react';
import { styles } from './ClosingTime.css';
import { getTwelveHourTimeFromString } from '@jbhi-fi/utils/src/date/getTwelveHourTimeFromString';

const getMessaging = (isOpen: boolean, closingTime?: string, openingTime?: string, openingDay = 'today') => {
  const message = isOpen
    ? closingTime
      ? ` today until ${getTwelveHourTimeFromString(closingTime)}`
      : ''
    : openingTime
    ? ` open ${openingDay} at ${getTwelveHourTimeFromString(openingTime)}`
    : '';

  return message;
};

export const ClosingTime = ({
  isOpen,
  closingTime,
  openingTime,
  openingDay,
}: {
  isOpen: boolean;
  closingTime?: string;
  openingTime?: string;
  openingDay?: string;
}) => {
  const status = isOpen ? 'Open' : 'Closed';

  return (
    <>
      <span
        data-testid="store-opening-hours-string"
        className={isOpen ? styles.open : styles.closed}
        data-status={status.toLowerCase()}
      >
        {status}
      </span>
      {getMessaging(isOpen, closingTime, openingTime, openingDay)}
    </>
  );
};
